module.exports = __webpack_public_path__ + "static/img/son2_active.e2632317.png";